import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import { Prod01 } from '../../constants/ActionType';
import PatientBasicsForm from './PatientBasicsForm';
import { selectedPrograms } from './ProgramEnrollmentFields';
import { formatCalendarDate, formatDateTime } from '../../utils/dateFormat';
import { notifyProgramStatusChanged } from '../../utils/programStatus';

const PatientProgramDetails = ({ patient }) => {
    const { user } = useSelector((state) => state.auth);
    const allowed = ['admin', 'adminStaff', 'HrLead', 'enrollment'].includes(user?.role);
    const [details, setDetails] = useState(null);
    const [editing, setEditing] = useState(false);
    const [error, setError] = useState('');
    const id = patient?._id;
    useEffect(() => {
        if (!allowed || !id) return;
        let active = true;
        setDetails(null);
        setError('');
        axios.get(`${Prod01}/enrollment/patients/${id}`).then(({ data }) => { if (active) setDetails(data); })
            .catch((err) => { if (active) setError(err?.response?.data?.message || err.message); });
        return () => { active = false; };
    }, [allowed, id]);
    if (!allowed || !patient) return null;
    const rows = details?.programEnrollments || [];
    const programs = [...new Set([...selectedPrograms(patient.patientType, patient.isCCM), ...rows.map((r) => r.program)])];
    const date = (value) => formatCalendarDate(value, 'Not recorded');
    return <div className="p-3 mt-3" style={{ border: '1px solid #ddd' }}>
        <h6>Program enrollment and consent</h6>
        {error ? <div className="alert alert-danger">{error}</div> : !details ? <p>Loading...</p> : programs.map((program) => {
            const row = rows.find((r) => r.program === program);
            return <div key={program} className="mb-2"><b>{program}</b>: start date {date(row?.startDate)};{' '}
                {row?.consentGiven === true ? <>Consent: Yes ({row.consentMethod}, {date(row.consentDate)}).<br />
                    <small>Recorded by {row.consentRecordedByLabel || 'Unknown user'}{row.consentRecordedAt ? ` at ${formatDateTime(row.consentRecordedAt)}` : ''}</small></> : row?.consentStatus === 'to_verify' ? 'Consent: verify at next contact' : 'Consent not recorded'}
            </div>;
        })}
        <button type="button" className="btn btn-primary btn-sm" disabled={!details} onClick={() => setEditing(true)}>Edit enrollment</button>
        <Modal show={editing} onHide={() => setEditing(false)} size="lg" centered><Modal.Header closeButton><Modal.Title>Program enrollment</Modal.Title></Modal.Header>
            <Modal.Body>{details && <PatientBasicsForm patient={details} onCancel={() => setEditing(false)} onSaved={(data) => { setDetails(data); setEditing(false); notifyProgramStatusChanged(id); }} />}</Modal.Body>
        </Modal>
    </div>;
};

export default PatientProgramDetails;
